const MS_PER_DAY = 86400000;

/**
 * Convert a date range to offsets relative to an event start date.
 * @param {string} eventStartDate - ISO date of the event start
 * @param {string|null} dateFrom - ISO date for range start (or null)
 * @param {string|null} dateTo - ISO date for range end (or null)
 * @returns {{ startOffset: number|null, endOffset: number|null }}
 */
export function dateRangeToOffsets(eventStartDate, dateFrom, dateTo) {
  const refDate = new Date(eventStartDate);

  const startOffset = dateFrom
    ? Math.floor((new Date(dateFrom) - refDate) / MS_PER_DAY)
    : null;

  const endOffset = dateTo
    ? Math.floor((new Date(dateTo) - refDate) / MS_PER_DAY)
    : null;

  return { startOffset, endOffset };
}
